import { z } from "zod/v4";

// Shape returned by GET /internal/v1/secrets:
// { workspaces: { [workspaceSlug]: { [profile]: string[] } } }
export const ListSecretsResponseSchema = z.object({
	workspaces: z.record(z.string(), z.record(z.string(), z.array(z.string()))),
});
export type ListSecretsResponse = z.infer<typeof ListSecretsResponseSchema>;

export const SecretResponseSchema = z.object({
	success: z.boolean(),
	message: z.string().default(""),
	secret_name: z.string().optional(),
});
export type SecretResponse = z.infer<typeof SecretResponseSchema>;

export type CreateSecretInput = {
	workspaceSlug: string;
	profile?: string;
	tokenName: string;
	secret: string;
};

export type DeleteSecretInput = {
	workspaceSlug: string;
	profile: string;
	tokenName: string;
};

export type SecretsproxyContext = {
	base_url: string;
	workspace_slug: string;
	profile: string;
	proxy_secret_names: string[];
	proxy_secret_names_status: "ok" | "unauthed" | "error";
};

export class SecretsProxyError extends Error {
	public status?: number;
	public resp?: Response;
	constructor(message: string, status?: number, resp?: Response) {
		super(message);
		this.name = "SecretsProxyError";
		this.status = status;
		this.resp = resp;
	}
}
